// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y6FW","top":"styles_top__Jpkam"};